// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4161":"54cd01c4","7731":"31d6cfe0"}[chunkId] + ".chunk.css";
};